module.exports = __webpack_public_path__ + "img/tab1s.c3366ee5.jpg";